import React from 'react';
import PropTypes from 'prop-types';

import './Stat.css';

const TrendBadge = ({ value }) => {
  if (value === null || value === undefined) return null;

  const isPositive = value >= 0;
  const badgeClass = isPositive ? 'tw-stat-trend--positive' : 'tw-stat-trend--negative';
  const arrow = isPositive ? '\u2191' : '\u2193';

  return (
    <span className={`tw-stat-trend ${badgeClass}`}>
      {arrow} {Math.abs(value)}%
    </span>
  );
};

const Stat = ({
  label,
  value,
  trend,
  loading,
  formatValue,
}) => {
  const displayValue = formatValue ? formatValue(value) : value?.toLocaleString();

  return (
    <div className="tw-stat">
      <p className="tw-stat-label">{label}</p>
      {loading ? (
        <div className="tw-stat-loading" />
      ) : (
        <div className="tw-stat-value-row">
          <span className="tw-stat-value">{displayValue}</span>
          <TrendBadge value={trend} />
        </div>
      )}
    </div>
  );
};

Stat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  trend: PropTypes.number,
  loading: PropTypes.bool,
  formatValue: PropTypes.func,
};

Stat.defaultProps = {
  value: 0,
  trend: null,
  loading: false,
  formatValue: null,
};

export default Stat;
